import { Lightbox } from '../classes/Lightbox';

document.addEventListener('DOMContentLoaded', () => {
	new Lightbox();
});
